import React from "react";


export const Heading: React.FC = (props) => {
    return <div className={"text-lg mb-6"}>
        {props.children}
    </div>
}